/**
 * Module dependencies.
 */

import { DescriptionWrapper } from '../products/products.style';
import { JSX, useMemo } from 'react';
import {
  StyledDescription,
  StyledTitle,
} from '../catalog-introduction/catalog-introduction.style';

import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  category: any;
};

/**
 * Export `CategoryIntroduction` component.
 */

export function CategoryIntroduction({ category }: Props): JSX.Element {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const { description, title } = useMemo(() => {
    return {
      description: category.description[lang],
      title: category.title[lang],
    };
  }, [category.description, category.title, lang]);

  return (
    <>
      <StyledTitle center>{title}</StyledTitle>

      <DescriptionWrapper>
        <StyledDescription>{description}</StyledDescription>
      </DescriptionWrapper>
    </>
  );
}
